import { ImageProps } from '@cox/core-ui8/dist/Image'

export enum AlignmentTypes {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right'
}

export enum AlignmentClasses {
  DEFAULT = '',
  LEFT = 'text-left',
  CENTER = 'text-center',
  RIGHT = 'text-end'
}

export interface ReactImageProps extends ImageProps {
  isInEditor?: boolean
  tokenProperties?: string
  token?: string
  top?: boolean
  right?: boolean
  bottom?: boolean
  left?: boolean
  lob?: string
  dmPresetType?: string
  imagePreset?: string
}

export enum LinkTypes {
  TAB = 'tab',
  PAGE = 'page',
  MODAL = 'modal',
  ACCORDION = 'accordion',
  COLLAPSE = 'collapse',
  CHAT = 'chat',
  PHONE = 'phone'
}
